export const ADD_PATIENT_FLOW = "add-patient";
const FLOW_QUERY_PARAM = "flow";

export const isAddPatientFlow = (search: string): boolean => {
  return new URLSearchParams(search).get(FLOW_QUERY_PARAM) === ADD_PATIENT_FLOW;
};

export const withOnboardingFlow = (path: string, search: string): string => {
  return isAddPatientFlow(search) ? `${path}?${FLOW_QUERY_PARAM}=${ADD_PATIENT_FLOW}` : path;
};
